/**
 * Base API
 * API for Base Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { FormatConfigEntry } from '../model/models';
import { FormatConfigResponse } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class BaseformatService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param kanton 
     * @param type 
     * @param path 
     * @param componentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFormat(kanton: string, type: 'BELEG' | 'BENUTZER' | 'BODENBEDECKUNG' | 'ZUSATZANGABEN' | 'CAPITITEL' | 'EIGENTUMANTEIL' | 'HANDELSANGABEN' | 'GEBAEUDE' | 'GEBAEUDEEINGANGSADRESSE' | 'GRUNDBUCHAMT' | 'GRUNDBUCHGESCHAEFT' | 'GEOMETERGESCHAEFT' | 'GRUNDBUCHPERSON' | 'GRUNDPFANDRECHT' | 'AMTLICHE_BEWERTUNG' | 'GRUNDPFANDRECHTBELASTUNG' | 'GRUNDSTUECK' | 'GRUNDSTUECKBESCHREIBUNG' | 'PERSONENADRESSE' | 'RECHTEID' | 'STAMMPERSON' | 'PERSONGB' | 'STANDARDRECHT' | 'TIMEPOINT' | 'AVMUTATION' | 'AMTNUMMER' | 'RECHTLISTITEM', path?: string, componentId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<FormatConfigEntry>;
    public getFormat(kanton: string, type: 'BELEG' | 'BENUTZER' | 'BODENBEDECKUNG' | 'ZUSATZANGABEN' | 'CAPITITEL' | 'EIGENTUMANTEIL' | 'HANDELSANGABEN' | 'GEBAEUDE' | 'GEBAEUDEEINGANGSADRESSE' | 'GRUNDBUCHAMT' | 'GRUNDBUCHGESCHAEFT' | 'GEOMETERGESCHAEFT' | 'GRUNDBUCHPERSON' | 'GRUNDPFANDRECHT' | 'AMTLICHE_BEWERTUNG' | 'GRUNDPFANDRECHTBELASTUNG' | 'GRUNDSTUECK' | 'GRUNDSTUECKBESCHREIBUNG' | 'PERSONENADRESSE' | 'RECHTEID' | 'STAMMPERSON' | 'PERSONGB' | 'STANDARDRECHT' | 'TIMEPOINT' | 'AVMUTATION' | 'AMTNUMMER' | 'RECHTLISTITEM', path?: string, componentId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<FormatConfigEntry>>;
    public getFormat(kanton: string, type: 'BELEG' | 'BENUTZER' | 'BODENBEDECKUNG' | 'ZUSATZANGABEN' | 'CAPITITEL' | 'EIGENTUMANTEIL' | 'HANDELSANGABEN' | 'GEBAEUDE' | 'GEBAEUDEEINGANGSADRESSE' | 'GRUNDBUCHAMT' | 'GRUNDBUCHGESCHAEFT' | 'GEOMETERGESCHAEFT' | 'GRUNDBUCHPERSON' | 'GRUNDPFANDRECHT' | 'AMTLICHE_BEWERTUNG' | 'GRUNDPFANDRECHTBELASTUNG' | 'GRUNDSTUECK' | 'GRUNDSTUECKBESCHREIBUNG' | 'PERSONENADRESSE' | 'RECHTEID' | 'STAMMPERSON' | 'PERSONGB' | 'STANDARDRECHT' | 'TIMEPOINT' | 'AVMUTATION' | 'AMTNUMMER' | 'RECHTLISTITEM', path?: string, componentId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<FormatConfigEntry>>;
    public getFormat(kanton: string, type: 'BELEG' | 'BENUTZER' | 'BODENBEDECKUNG' | 'ZUSATZANGABEN' | 'CAPITITEL' | 'EIGENTUMANTEIL' | 'HANDELSANGABEN' | 'GEBAEUDE' | 'GEBAEUDEEINGANGSADRESSE' | 'GRUNDBUCHAMT' | 'GRUNDBUCHGESCHAEFT' | 'GEOMETERGESCHAEFT' | 'GRUNDBUCHPERSON' | 'GRUNDPFANDRECHT' | 'AMTLICHE_BEWERTUNG' | 'GRUNDPFANDRECHTBELASTUNG' | 'GRUNDSTUECK' | 'GRUNDSTUECKBESCHREIBUNG' | 'PERSONENADRESSE' | 'RECHTEID' | 'STAMMPERSON' | 'PERSONGB' | 'STANDARDRECHT' | 'TIMEPOINT' | 'AVMUTATION' | 'AMTNUMMER' | 'RECHTLISTITEM', path?: string, componentId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (kanton === null || kanton === undefined) {
            throw new Error('Required parameter kanton was null or undefined when calling getFormat.');
        }
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling getFormat.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (path !== undefined && path !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>path, 'path');
        }
        if (componentId !== undefined && componentId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>componentId, 'componentId');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<FormatConfigEntry>(`${this.configuration.basePath}/base/format/${encodeURIComponent(String(kanton))}/${encodeURIComponent(String(type))}`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param kanton 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFormatConfig(kanton: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<FormatConfigResponse>;
    public getFormatConfig(kanton: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<FormatConfigResponse>>;
    public getFormatConfig(kanton: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<FormatConfigResponse>>;
    public getFormatConfig(kanton: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (kanton === null || kanton === undefined) {
            throw new Error('Required parameter kanton was null or undefined when calling getFormatConfig.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<FormatConfigResponse>(`${this.configuration.basePath}/base/format/all/${encodeURIComponent(String(kanton))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
